import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { CheckCircle, ArrowLeft } from 'lucide-react';

const ThankYou = () => {
  const location = useLocation();
  const { formType = 'form' } = location.state || {};

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Google Tag Manager tracking
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'page_view',
        page_title: 'Thank You Page',
        page_location: window.location.href,
      });
      
      // Track form submission event
      window.dataLayer.push({
        event: 'form_submission',
        event_category: 'Form',
        event_label: formType === 'quote' ? 'Quote Form' : 
                    formType === 'contact' ? 'Contact Form' : 
                    formType === 'home-quote' ? 'Home Quote Form' : 'Unknown Form',
        value: 1
      });
    }
    
    // Meta Pixel tracking
    if (typeof window.fbq !== 'undefined') {
      window.fbq('track', 'Lead', {
        content_name: formType === 'quote' ? 'Quote Form' : 
                     formType === 'contact' ? 'Contact Form' : 
                     formType === 'home-quote' ? 'Home Quote Form' : 'Unknown Form'
      });
    }
  }, [formType]);

  // Get the appropriate back path based on form type
  const getBackPath = () => {
    switch (formType) {
      case 'quote':
        return '/get-quoted';
      case 'contact':
        return '/contact-us';
      case 'home-quote':
        return '/';
      default:
        return '/';
    }
  };

  const getFormTitle = () => {
    switch (formType) {
      case 'quote':
        return 'Quote Request';
      case 'contact':
        return 'Contact Form';
      case 'home-quote':
        return 'Quote Request';
      default:
        return 'Form';
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex flex-col">
      <Navbar />

      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center px-6 py-20">
        <div className="max-w-2xl w-full text-center">
          {/* Success Icon */}
          <div className="mb-8 flex justify-center">
            <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center shadow-lg">
              <CheckCircle className="w-12 h-12 text-green-600" />
            </div>
          </div>

          {/* Success Message */}
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Thank You!
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-700 mb-8">
            Your {getFormTitle()} has been submitted successfully.
          </p>

          <p className="text-lg text-gray-600 mb-12 max-w-lg mx-auto">
            We have received your submission and will get back to you as soon as possible. 
            Our team will review your information and contact you shortly.
          </p>

          {/* Back Button */}
          <Link
            to={getBackPath()}
            className="inline-flex items-center gap-3 bg-blue-600 text-white px-8 py-4 rounded-lg 
                     hover:bg-blue-700 transition-colors duration-200 font-semibold text-lg
                     shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            <ArrowLeft className="w-5 h-5" />
            Back to {formType === 'home-quote' ? 'Home' : getFormTitle()}
          </Link>

          {/* Additional Links */}
          {/* <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-2xl mx-auto">
            <Link
              to="/"
              className="p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
            >
              <h3 className="font-semibold text-gray-900 mb-2">Home</h3>
              <p className="text-gray-600 text-sm">Return to our homepage</p>
            </Link>
            
            <Link
              to="/ourproducts"
              className="p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
            >
              <h3 className="font-semibold text-gray-900 mb-2">Our Products</h3>
              <p className="text-gray-600 text-sm">Explore our solutions</p>
            </Link>
            
            <Link
              to="/contact"
              className="p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
            >
              <h3 className="font-semibold text-gray-900 mb-2">Contact Us</h3>
              <p className="text-gray-600 text-sm">Get in touch with our team</p>
            </Link>
          </div> */}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ThankYou;
